import React from "react";
import {Col, Row, Container} from "react-bootstrap";
import imgIntro from "../../../../images/intro/intro_new.png";

const Intro = () => {
    return (
        <Container>
            <div className={'base-box-pages-second'}>
                <div className={'base-box-page-about-us'}>
                    <Row className="justify-content-center">
                        <Col xs={12} md={10} lg={8}>
                            <div >
                                <img src={imgIntro} alt="" className="w-100" />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </Container>
    )
}

export default Intro;
